import { RouteStatus } from './route';

export * from './route';
export * from './tracking';
export * from './directions';

export interface QueryParameters {
  startDateTimeUtc: string;
  endDateTimeUtc: string;
  searchTerm: string | null;
}

export interface SearchResponse {
  deliveryRunReference: string;
  fleetNumber: string;
  registrationNumber: string;
  routeStatus: RouteStatus;
  searchResultType: SearchResultType;
  startDateTimeUtc: string;
  trackingDeviceIdentifier: string;
  trackingDeviceType: string;
}

export enum SearchResultType {
  trackable = 'Trackable',
  route = 'Route'
}
